import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdmissionDateComponent } from 'src/app/kiosk/components/admission-date/admission-date/admission-date.component';
import { AgreementComponent } from 'src/app/kiosk/components/agreement/agreement/agreement.component';
import { LoginComponent } from 'src/app/kiosk/components/authentication/login/login.component';
import { CardScanComponent } from 'src/app/kiosk/components/card-scan/card-scan/card-scan.component';
import { CityComponent } from 'src/app/kiosk/components/city/city/city.component';
import { ContractComponent } from 'src/app/kiosk/components/contract/contract/contract.component';
import { ErrorPageComponent } from 'src/app/kiosk/components/error/error-page/error-page.component';
import { CheckPreHospiComponent } from 'src/app/kiosk/components/hospi/check-prehospi/check-prehospi.component';
import { SelectInsurerComponent } from 'src/app/kiosk/components/insurer/select-insurer/select-insurer.component';
import { SelectLanguageComponent } from 'src/app/kiosk/components/language/select-language/select-language.component';
import { LightComponent } from 'src/app/kiosk/components/light/light/light.component';
import { MaintenancesComponent } from 'src/app/kiosk/components/maintenance/maintenances.component';
import { PatientDobComponent } from 'src/app/kiosk/components/patient/patient-dob/patient-dob.component';
import { ProvinceComponent } from 'src/app/kiosk/components/province/province/province.component';
import { ConfirmQuestionComponent } from 'src/app/kiosk/components/question/confirm-question/confirm-question.component';
import { QuestionComponent } from 'src/app/kiosk/components/question/question/question.component';
import { ScreenSaverComponent } from 'src/app/kiosk/components/screensaver/screensaver/screen-saver.component';
import { ConfirmSiteComponent } from 'src/app/kiosk/components/site/confirm-site/confirm-site.component';
import { SiteComponent } from 'src/app/kiosk/components/site/site/site.component';
import { PageGuard } from './guard/page-guard';

const routes: Routes = [
   { path: '', redirectTo: 'app-login', pathMatch: 'full' },
 
  {
    path: "app-login",
    component: LoginComponent,
  },
  {
    path: "error",
    component: ErrorPageComponent,
  },
  {
    path: "screen-saver",
    component: ScreenSaverComponent,
    canActivate:[PageGuard]
  },
  {
    path: "select-language",
    component: SelectLanguageComponent,
    canActivate:[PageGuard]
  },
  {
    path: "card-scan",
    component: CardScanComponent,
    canActivate:[PageGuard]
  },
  {
    path: "select-insurer",
    component: SelectInsurerComponent,
    canActivate:[PageGuard]
  },
  {
    path: "enter-card-id",
    component: ContractComponent,
    canActivate:[PageGuard]
  },
  {
    path: "enter-patient-dob",
    component: PatientDobComponent,
    canActivate:[PageGuard]
  },
  {
    path: "agreement",
    component: AgreementComponent,
    canActivate:[PageGuard]
  },
  {
    path: "enter-admission-date",
    component: AdmissionDateComponent,
    canActivate:[PageGuard]
  },
  {
    path: "province",
    component: ProvinceComponent,
    canActivate:[PageGuard]
  },
  {
    path: "city",
    component: CityComponent,
    canActivate:[PageGuard]
  },
  {
    path: "hospital",
    component: SiteComponent,
    canActivate:[PageGuard]
  },
  {
    path: "confirm-hospital",
    component: ConfirmSiteComponent,
    canActivate:[PageGuard]
  },
  {
    path: "check-prehospi",
    component: CheckPreHospiComponent,
    canActivate:[PageGuard]
  },
  {
    path: "question",
    component: QuestionComponent,
    canActivate:[PageGuard]
  },
  {
    path: "confirm-question",
    component: ConfirmQuestionComponent,
    canActivate:[PageGuard]
  },
  {
    path: "light",
    component: LightComponent,
    canActivate:[PageGuard]
  },
  {
    path: "maintenance",
    component: MaintenancesComponent,
  }
,
 {
    path:"**",
    redirectTo:"app-login"
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
